/** Раскрывашка-карточка: заголовок с шевроном, по тапу под ним открывается содержимое. */
import { useId, useState } from 'react';
import type { ReactElement, ReactNode } from 'react';
import * as telegram from '../lib/telegram';

export function Disclosure({ title, children }: { title: string; children: ReactNode }): ReactElement {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div className={'disclosure' + (open ? ' open' : '')}>
      <button type="button" className="disclosure-toggle" aria-expanded={open} aria-controls={id}
        onClick={() => { telegram.hapticFeedback.selection(); setOpen(value => !value); }}>
        <span>{title}</span>
        <span className="chevron" aria-hidden="true" />
      </button>
      {open ? <div id={id} className="disclosure-body">{children}</div> : null}
    </div>
  );
}
